var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUndo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5349 19.25V12.2228C17.5349 10.1518 15.8561 8.47296 13.7851 8.47296H8.5353L10.7552 6.28304C10.8972 6.14222 10.9771 5.95053 10.9771 5.75056C10.9771 5.55059 10.8972 5.35891 10.7552 5.21809C10.4627 4.9273 9.99027 4.9273 9.69775 5.21809L6.22539 8.69045C6.15442 8.7611 6.09832 8.84525 6.0604 8.93794C5.98017 9.11946 5.98017 9.32639 6.0604 9.50792C6.10116 9.59906 6.15694 9.68272 6.22539 9.75541L9.69775 13.2503C9.99531 13.5051 10.4389 13.488 10.7159 13.2109C10.9929 12.9339 11.01 12.4904 10.7552 12.1928L8.5653 9.9729H13.8151C15.0577 9.9729 16.065 10.9802 16.065 12.2228V19.25C16.065 19.6642 16.4008 20 16.815 20C17.2292 20 17.5649 19.6642 17.5649 19.25H17.5349Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default ForwardRef;